import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import { Modal, Tooltip, message } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 75 },
    { key: 'orgName', label: '部门名称', width: 150 },
    { key: 'employeeName', label: '教师姓名', width: 90 },
    { key: 'employeeCode', label: '教师编号', width: 100 },
    { key: 'employeeProperty', label: '教师类型', width: 100 },
    { key: 'standardFinalScore', label: '最终得分（标准分）', width: 110 },
    { key: 'finalRank', label: '最终排名', width: 90 },
    { key: 'finalGrade', label: '最终等级', width: 90 },
    {
        key: 'calculateDetail', label: '计算详情', width: 90,
        render: (value) => <Tooltip title={value} />
    },
    { key: 'termName', label: '学年' }
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('eval/allYearSsti/list?' + params.join('&'), keywords)
        .then(response => {
            const columns = [
                { type: 'selection' },
                { key: '$index', label: '序号', width: 75 },
                { key: 'orgName', label: '部门名称', width: 150 },
                { key: 'employeeName', label: '教师姓名', width: 90 },
                { key: 'employeeCode', label: '教师编号', width: 100 },
                { key: 'employeeProperty', label: '教师类型', width: 100 },
                { key: 'standardFinalScore', label: '最终得分（标准分）', width: 110 },
                { key: 'finalRank', label: '最终排名', width: 90 },
                { key: 'finalGrade', label: '最终等级', width: 90 },
                {
                    key: 'calculateDetail', label: '计算详情', width: 90,
                    render: (value) => {
                        return <Tooltip title={value}>{value}</Tooltip>
                    }
                },
            ];

            response.payload.meta.extParams.evalList.forEach((index) => {
                columns.push({ key: 'evalName' + index, label: '评价方 ' + index, width: 110 });
                columns.push({ key: 'count' + index, label: '总数 ', width: 70 });
                columns.push({ key: 'evalScore' + index, label: '原始分数', width: 90 });
                columns.push({ key: 'evalWeight' + index, label: '权重', width: 70 });
                columns.push({ key: 'rank' + index, label: '排名', width: 70 });
                columns.push({ key: 'standardScore' + index, label: '标准分', width: 90 });
            });
            columns.push({ key: 'termName', label: '学年' })
            return {
                headers: utils.columns(columns),
                data: response.payload.data
            };
        })
        .then(response => (Object.assign({
            headers: response.headers,
            result: response.data.dataList || [],
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * 清空本学期汇总数据
 */
const removeAllData = (keywords = {}) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                fetch.post('eval/allYear/removeAll', keywords)
                    .then((response) => {
                        if (response.code === 200) {
                            message.success(response.message);
                            resolve(true);
                        } else {
                            reject();
                        }
                    });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    })
}

/** 
 * 计算各测评方分数
*/
const calculate = (keywords = {}) => {
    return new Promise(function (resolve, reject) {
        fetch.post('eval/allYearSsti/calculate', keywords)
            .then((response) => {
                if (response.code === 200) {
                    message.success(`计算成功！`);
                    resolve(true);
                } else {
                    reject()
                }
            });
    })
}

/** 
 * 计算最终等级
*/
const gradeAndRank = (keywords = {}) => {
    return new Promise(function (resolve, reject) {
        fetch.post('eval/allYearSsti/gradeAndRank', keywords)
            .then((response) => {
                if (response.code === 200) {
                    message.success(`计算成功！`);
                    resolve(true);
                } else {
                    reject()
                }
            });
    })
}

/** 
 * 查询单条数据
 */
const querySearchById = (id) => {
    return new Promise(function (resolve, reject) {
        fetch.get('eval/allYear/get/' + id)
            .then((response) => {
                if (response.code === 200) {
                    resolve(response.payload.data);
                } else {
                    reject()
                }
            });
    })
}

/**
 * 更新单条数据
 */
const update = (id, data) => {
    return fetch.post('eval/allYear/update/' + id, data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '信息更新成功!',
                    content: (
                        <div>
                            <p>点击确认后，将自动跳转到管理页面！</p>
                        </div>
                    ),
                    onOk() {
                        window.location.hash = 'mulEval/listTotalByEmpYear/index';
                    },
                });
            }
        });
}

/**
 * 删除数据
 */
const remove = (ids) => {
    return fetch.post('eval/allYear/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if (DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText: "确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if (response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'mulEval/listTotalByEmpYear' + url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if (DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText: "确认",
        });
    } else {
        redirect('/update/' + DataGrid.selections[0]);
    }
}

const getSelection = () => {
    return DataGrid.selections;
}

const generate = () => {
    return fetch.post('eval/allYearSsti/generate')
}

const get = (id) => {
    return fetch.get(`eval/allYearSsti/get/${id}`)
}

const updateGrade = (data) => {
    return fetch.post(`eval/allYearSsti/updateGrade`, data)
}

export default {
    querySearch,
    update,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    removeAllData,
    calculate,
    getSelection,
    querySearchById,
    generate,
    gradeAndRank,
    get,
    updateGrade
}